module.exports = __webpack_public_path__ + "img/cloud-wind-2.ea318d5b.svg";